import React, {useEffect, useState} from 'react';
import ShowLink from "../../../common/ui/show-link";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_MULTI_PRODUCTS_DESIGNER_TAB,
    DEFAULT_MULTI_PRODUCTS_SETTINGS, DESIGN_KEY_PREFIX, DESIGN_VARIANT_STATUS, MULTI_PRODUCT_DESIGNER_KEYS,
    MULTI_PRODUCTS_DESIGNER_TABS_LIST
} from "../../constants/design.constant";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import _ from "lodash";
import Promise from "bluebird";
import {searchQuotesWithSearchCriteria} from "../../../common/services/quote-data-service";
import SelectParentProductList from "../../../pod/components/parent-product/select-parent-product-list";
import SelectImageList from "../../../image/select-multiple-image-list/select-image-list";
import {searchTags} from "../../../common/services/tag-data-service";
import ProductsDesigner from "./products-designer";
import {prepareDesignName, prepareSEODesignName, processDesignVariantStatistics} from "../../utils/design-util";
import {getImageDownloadUrl, setImageSize} from "../../../common/utils/image-util";
import {getNextItemKey} from "../../../common/utils/item-key-util";
import {ArrowDownOnSquareIcon, EyeIcon, EyeSlashIcon} from "@heroicons/react/24/solid";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {addSingleDesign, updateSingleDesign} from "../../services/design-data-service";
import {processDesignVariantDetail, processImagesLayer, processTextItemsLayer} from "../../utils/design-variant-util";
import {addSingleDesignVariant} from "../../services/design-variant-data-service";
import {getDataFromLocalStorage, setDataInLocalStorage} from "../../../common/utils/local-storage-util";
import {SHOPIFY_KEYS} from "../../../shopify/constants/shopify.constant";

const tabsList = MULTI_PRODUCTS_DESIGNER_TABS_LIST;

const MultiProductsDesignerDashboard = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_MULTI_PRODUCTS_DESIGNER_TAB);
    const [commonDetail, setCommonDetail] = useState(null);
    const [selectedParentProductList, setSelectedParentProductList] = useState([]);
    const [selectedImageList, setSelectedImageList] = useState([]);
    const [processedImageList, setProcessedImageList] = useState([]);
    const [podList, setPodList] = useState(null);
    const [themeList, setThemeList] = useState(null);
    const [quoteList, setQuoteList] = useState(null);
    const [tagList, setTagList] = useState(null);
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedPod, setSelectedPod] = useState(null);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    const [parentProductFilterCriteria, setParentProductFilterCriteria] = useState(null);
    const [imageFilterCriteria, setImageFilterCriteria] = useState(null);
    const [designsMap, setDesignsMap] = useState(null);
    const [imageIdsList, setImageIdsList] = useState([]);
    const [showGrid, setShowGrid] = useState(true);
    const [downloadAllImages, setDownloadAllImages] = useState(false);
    const [saveInProgress, setSaveInProgress] = useState(false);

    useEffect(() => {
        if (initialStep) {
            init();
            /*getAllPodList();
            getAllThemeList();
            getAllTagsList();*/
        }
    }, [initialStep]);

    const init = async () => {
        const existingCommonDetail = getDataFromLocalStorage(MULTI_PRODUCT_DESIGNER_KEYS.COMMON_DETAIL);

        console.log('init() -> existingCommonDetail', existingCommonDetail);

        await getAllPodList(existingCommonDetail?.podId);
        await getAllThemeList(existingCommonDetail?.themeId);
        await getAllTagsList();

        if (existingCommonDetail) {
            setCommonDetail(existingCommonDetail);
        }

        if (existingCommonDetail?.themeId) {
            await getAllQuoteList(existingCommonDetail?.themeId, existingCommonDetail?.quoteId);
        }
    }

    useEffect(() => {
        if (selectedPod && selectedTheme && selectedQuote) {
            prepareDesignsMap();
        }
    }, [selectedParentProductList, selectedTheme, selectedQuote]);

    const prepareDesignsMap = () => {
        const existingDesignsMap = {...designsMap} || {};
        const existingCommonDetail = {...commonDetail};
        const selectedParentProductIdList = _.map(selectedParentProductList, 'id');
        const newDesignsMap = {};
        let currentSelectedParentProduct;

        console.log('prepareDesignsMap() -> existingDesignsMap', existingDesignsMap);

        _.forEach(selectedParentProductList, parentProduct => {
            if (!existingDesignsMap.hasOwnProperty(parentProduct?.id)) {
                const newDesign = _.cloneDeep(commonDetail);
                newDesign.name = prepareDesignName(selectedPod, selectedTheme, selectedQuote, parentProduct);
                newDesign.seoName = prepareSEODesignName(selectedPod, selectedTheme, selectedQuote, parentProduct);
                newDesign.quoteName = selectedQuote.startText;
                newDesign.themeName = selectedTheme.startText;
                newDesign.category = parentProduct.category;
                newDesign.productType = parentProduct.productType;
                newDesign.parent = parentProduct.name;
                newDesign.parentId = parentProduct.id;

                newDesign.settings = _.cloneDeep(DEFAULT_MULTI_PRODUCTS_SETTINGS);
                newDesign.settings.width = parentProduct.widthPixel;
                newDesign.settings.height = parentProduct.heightPixel;

                existingDesignsMap[parentProduct?.id] = newDesign;
            }
        });

        _.forIn(existingDesignsMap, (design, parentId) => {
            if (selectedParentProductIdList.indexOf(parentId) !== -1) {
                newDesignsMap[parentId] = design;

                if (_.isEmpty(currentSelectedParentProduct)) {
                    currentSelectedParentProduct = design;
                }
            }
        });

        setDesignsMap(newDesignsMap);

        if (currentSelectedParentProduct) {
            const event = {
                target: {
                    name: 'parentId',
                    value: currentSelectedParentProduct.parentId
                }
            };

            handleCommonDetailChanges(event);
        }
    }

    const getAllPodList = async (currentPodId = '') => {
        const podListResult = await searchPods('');
        const defaultPods = _.filter(podListResult, ['isDefault', true]);

        setPodList(podListResult);

        if (currentPodId) {
            const currentPod = _.find(podListResult, ['id', currentPodId]);

            if (currentPod) {
                setSelectedPod(currentPod);
            }
        } else if (!_.isEmpty(defaultPods)) {
            setSelectedPod(defaultPods[0]);
            /*const event = {
                target: {
                    name: 'podId',
                    value: defaultPods[0].id
                }
            };

            handleCommonDetailChanges(event, podListResult);*/
        }
    }

    const getAllTagsList = async () => {
        const tagsListResult = await searchTags('');
        setTagList(tagsListResult);
    }

    const getAllThemeList = async (currentThemeId = '') => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));

        if (currentThemeId) {
            const currentTheme = _.find(themeListResult, ['id', currentThemeId]);

            if (currentTheme) {
                setSelectedTheme(currentTheme);
            }
        }
    }

    const getAllQuoteList = async (themeId?, currentQuoteId?) => {
        const quoteListResult = await searchQuotesWithSearchCriteria(prepareSearchCriteria(themeId));
        setQuoteList(_.orderBy(quoteListResult, ['startText']));

        if (currentQuoteId) {
            const currentQuote = _.find(quoteListResult, ['id', currentQuoteId]);

            if (currentQuote) {
                setSelectedQuote(currentQuote);
            }
        }
    }

    const prepareSearchCriteria = (themeId?) => {
        const searchCriteriaList = [];
        const currentTheme = {...selectedTheme};

        if (themeId) {
            searchCriteriaList.push({
                field: 'themes.' + themeId,
                condition: '==',
                value: true
            });
        } else if (!_.isEmpty(currentTheme)) {
            searchCriteriaList.push({
                field: 'themes.' + currentTheme?.id,
                condition: '==',
                value: true
            });
        }

        return searchCriteriaList;
    }

    const handleCommonDetailChanges = (event, newPodList?) => {
        const {
            name,
            value
        } = event.target;
        const existingCommonDetail = {...commonDetail};
        existingCommonDetail[name] = value;

        let currentPod = {...selectedPod};
        let currentTheme = {...selectedTheme};
        let currentQuote = {...selectedQuote};
        let currentParentProduct = {...selectedParentProduct};

        if (name === 'podId') {
            const podsMap = _.keyBy(newPodList || podList, 'id');
            currentPod = podsMap[value];
            setSelectedPod(currentPod);

            existingCommonDetail.market = currentPod?.market;
            existingCommonDetail.podName = currentPod?.name;
        } else if (name === 'themeId') {
            const themeMap = _.keyBy(themeList, 'id');
            currentTheme = themeMap[value];
            setSelectedTheme(currentTheme);

            existingCommonDetail.themeName = currentTheme?.startText;
            getAllQuoteList(value, '');
        } else if (name === 'quoteId') {
            const quoteMap = _.keyBy(quoteList, 'id');
            currentQuote = quoteMap[value];
            setSelectedQuote(currentQuote);

            existingCommonDetail.quoteName = currentQuote?.startText;
        } else if (name === 'parentId') {
            const parentProductMap = _.keyBy(selectedParentProductList, 'id');
            currentParentProduct = parentProductMap[value];
            setSelectedParentProduct(currentParentProduct);
        }

        setCommonDetail(existingCommonDetail);
        setDataInLocalStorage(MULTI_PRODUCT_DESIGNER_KEYS.COMMON_DETAIL, existingCommonDetail);
    }

    useEffect(() => {
        if (selectedTab && selectedTab?.key !== 'images') {
            prepareSelectedImageList();
        }

    }, [selectedTab]);

    const prepareSelectedImageList = async () => {
        const newProcessedImageList = [];
        const existingProcessedImageList = [...processedImageList];
        const existingImageIdsList = imageIdsList;
        const existingSelectedImageList = [...selectedImageList];
        const selectedImageIdList = _.map(existingSelectedImageList, 'id');

        await Promise.mapSeries(existingSelectedImageList, async addedImage => {
            if (existingImageIdsList.indexOf(addedImage?.id) === -1) {
                existingImageIdsList.push(addedImage?.id);
                setImageIdsList(existingImageIdsList);

                const imageDetail = await processAddedImageShape(addedImage, existingProcessedImageList);

                if (imageDetail) {
                    existingProcessedImageList.push(imageDetail);
                }
            }
        });

        _.forEach(existingProcessedImageList, processedImage => {
            if (selectedImageIdList.indexOf(processedImage.id) !== -1) {
                newProcessedImageList.push(processedImage);
            }
        });

        setProcessedImageList(newProcessedImageList);
        setImageIdsList(_.map(newProcessedImageList, 'id'));
    }


    const processAddedImageShape = async (addedImage, existingImages) => {
        let imageDetail;
        await getImageDownloadUrl(addedImage);

        if (addedImage?.downloadUrl) {
            if (!addedImage.height || !addedImage.width) {
                await setImageSize(addedImage);
            }

            imageDetail = {
                key: getNextItemKey(existingImages, DESIGN_KEY_PREFIX.IMAGE),
                x: 0,
                y: 0,
                width: addedImage.width,
                height: addedImage.height,
                imageWidth: addedImage.width,
                imageHeight: addedImage.height,
                id: addedImage?.id,
                src: addedImage?.downloadUrl,
                url: addedImage?.downloadUrl,
                fileUrl: addedImage?.fileUrl,
                displayLabel: addedImage?.displayLabel,
                thumbnail: addedImage?.thumbnail,
            }
        }

        return imageDetail;
    }

    const toggleShowGrid = (e) => {
        setShowGrid(!showGrid);
    }

    const saveAllDesigns = async () => {
        setSaveInProgress(true);
        const addedNewDesignList = [];

        const existingDesignsMap = {...designsMap};
        const newDesignList = _.values(existingDesignsMap);

        await Promise.all(
            newDesignList.map(async (newDesignDetail) => {
                if (!newDesignDetail?.id) {
                    const designDetail = prepareDesignDetails(newDesignDetail);
                    const addedDesign: any = await addSingleDesign(designDetail);
                    designDetail.id = addedDesign.id;

                    await saveAllDesignVariants(designDetail, newDesignDetail.settings)
                    addedNewDesignList.push(designDetail);
                }
            })
        );

        setSaveInProgress(false);
    }

    const prepareDesignDetails = (newDesignDetail) => {
        const designDetail = _.cloneDeep(newDesignDetail);
        delete designDetail.settings;
        delete designDetail.stageContainer;
        return designDetail;
    }

    const saveAllDesignVariants = async (existingDesignDetail, existingSettings) => {
        const existingVariants = existingDesignDetail.variants || [];

        await Promise.mapSeries(existingSettings.designVariants, async newDesignVariant => {
            newDesignVariant.designId = existingDesignDetail.id;
            newDesignVariant.status = DESIGN_VARIANT_STATUS.READY_TO_PUBLISH;
            await addNewDesignVariant(newDesignVariant, existingDesignDetail, existingSettings, existingVariants);
        });

        existingDesignDetail.variants = existingVariants;
        prepareDesignBatch(existingDesignDetail, existingSettings);
        processDesignVariantStatistics(existingDesignDetail);

        await updateSingleDesign(existingDesignDetail);
    }

    const addNewDesignVariant = async (newDesignVariant, existingDesignDetail, existingSettings, existingVariants) => {
        const newVariant: any = {};
        newDesignVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);

        newVariant.designId = newDesignVariant.designId;
        newVariant.name = newDesignVariant.name;
        newVariant.key = newDesignVariant.key;
        newVariant.status = newDesignVariant.status;
        newVariant.batchKey = newDesignVariant.batchKey;

        processDesignVariantDetail(newDesignVariant, existingDesignDetail, selectedQuote, selectedParentProduct);
        newDesignVariant.settings.background = existingSettings?.background;
        newDesignVariant.settings.noText = true;
        newDesignVariant.batchSettings = prepareDesignBatchSettings(existingSettings);

        processTextItemsLayer(newDesignVariant);
        processImagesLayer(newDesignVariant);

        const addedVariant: any = await addSingleDesignVariant(newDesignVariant);
        newVariant.id = addedVariant.id;
        existingVariants.push(newVariant);
    }

    const prepareDesignBatch = (existingDesignDetail, existingSettings) => {
        const existingCommonSettings = existingSettings;
        const designBatch: any = {
            batchKey: existingCommonSettings.batchKey,
            stageContainer: existingCommonSettings.stageContainer,
            background: existingCommonSettings.background,
            noText: existingCommonSettings.noText,
            isRepeatImage: existingCommonSettings.isRepeatImage,
            isBackgroundImage: existingCommonSettings.isBackgroundImage,
            size: existingCommonSettings.size,
            width: existingCommonSettings.width,
            height: existingCommonSettings.height,
            fillPatternOffsetXPercentage: existingCommonSettings.fillPatternOffsetXPercentage,
            fillPatternOffsetYPercentage: existingCommonSettings.fillPatternOffsetYPercentage,
            fillPatternRotation: existingCommonSettings.fillPatternRotation,
            fillPatternRepeat: existingCommonSettings.fillPatternRepeat,
        }

        const existingBatches = existingDesignDetail?.batches || [];
        existingBatches.push(designBatch);
        existingDesignDetail.batches = existingBatches;
    }

    const prepareDesignBatchSettings = (existingSettings) => {
        const batchSettings = _.cloneDeep(existingSettings);
        delete batchSettings.designVariants;
        delete batchSettings.images;
        return batchSettings;
    }

    useEffect(() => {
        console.log('selectedParentProductList', selectedParentProductList, selectedTheme, selectedQuote);
    }, [selectedParentProductList]);


    return (
        <>

            <div className="page-container-background design-dashboard-container">

                <div className="items-center justify-start p-8 mb-28 w-full">
                    <div className="flex items-center justify-start m-2 pb-2">
                        <div className="mr-4">
                            <ShowLink label="Back"
                                      url="/designs"/>
                        </div>

                        <div className="text-2xl w-96">
                            Multi Products Designer
                        </div>

                        <div className="field-group-container -mt-4">

                            <div className="field-container">
                                <div className="field-label">
                                    POD <span
                                    className="text-gray-400">({podList?.length})</span>
                                </div>
                                <select
                                    className="input-field"
                                    id="podId"
                                    name="podId"
                                    value={commonDetail?.podId}
                                    onChange={handleCommonDetailChanges}>
                                    <option value="">Choose POD</option>
                                    {podList?.map((pod, index) => (
                                        <option key={index}
                                                value={pod?.id}>{pod?.displayLabel}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="field-container">
                                <div className="field-label">
                                    Theme
                                </div>
                                <select
                                    className="input-field"
                                    id="themeId"
                                    name="themeId"
                                    value={commonDetail?.themeId}
                                    onChange={handleCommonDetailChanges}>
                                    <option value="">Choose Theme</option>
                                    {themeList?.map((theme, index) => (
                                        <option key={index}
                                                value={theme?.id}>{theme?.startText}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="field-container">
                                <div className="field-label">
                                    Quote
                                </div>
                                <select
                                    className="input-field"
                                    id="quoteId"
                                    name="quoteId"
                                    value={commonDetail?.quoteId}
                                    onChange={handleCommonDetailChanges}>
                                    <option value="">Choose Quote</option>
                                    {quoteList?.map((quote, index) => (
                                        <option key={index}
                                                value={quote?.id}>{quote?.startText}</option>
                                    ))}
                                </select>
                            </div>

                            {/*{selectedParentProductList?.length > 0 &&
                                <div className="field-container">
                                    <div className="field-label text-purple-600">
                                        Selected Parent Products
                                    </div>
                                    <select
                                        className="input-field"
                                        id="parentId"
                                        name="parentId"
                                        value={commonDetail?.parentId}
                                        onChange={handleCommonDetailChanges}>
                                        <option value="">Choose Parent Product</option>
                                        {selectedParentProductList?.map((selectedParentProduct, index) => (
                                            <option key={index}
                                                    value={selectedParentProduct?.id}>{selectedParentProduct?.productType} / {selectedParentProduct?.category} / {selectedParentProduct?.name}</option>
                                        ))}
                                    </select>
                                </div>
                            }*/}

                            <div className="flex justify-start items-center mt-7">
                                {selectedParentProductList?.length > 0 &&
                                    <>

                                        <div className="mx-2">
                                            <button onClick={toggleShowGrid}
                                                    className="button-outline-gray mt-1">
                                                {showGrid &&
                                                    <div className="p-2">
                                                        <EyeIcon className="h-6 w-6"/>
                                                    </div>
                                                }

                                                {!showGrid &&
                                                    <div className="p-2">
                                                        <EyeSlashIcon className="h-6 w-6"/>
                                                    </div>
                                                }
                                            </button>
                                        </div>

                                        {selectedPod && selectedQuote && selectedTheme &&

                                            <>
                                                <div className="mx-2">
                                                    <button onClick={() => {
                                                        setDownloadAllImages(true);
                                                    }}
                                                            className="button-gray py-2 px-3 flex justify-center">
                                                        <div className="pr-2">
                                                            <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                                        </div>
                                                        Download All
                                                    </button>
                                                </div>

                                                <div className={"mx-2"}>
                                                    <button onClick={saveAllDesigns}
                                                            className="button-green py-2 px-3 flex justify-center">
                                                        Save All Designs
                                                    </button>
                                                </div>

                                                <div className="mx-2">
                                                    <ShowProgressSpinner
                                                        dataFetchInProgress={downloadAllImages || saveInProgress}/>
                                                </div>
                                            </>

                                        }

                                    </>
                                }
                            </div>

                        </div>

                    </div>

                    <div className="mt-4">
                        <ShowTabsList
                            setSelectedTab={setSelectedTab}
                            selectedTab={selectedTab}
                            tabsList={tabsList}/>
                    </div>

                    {selectedPod && selectedTab?.key === 'parent-products' &&
                        <div>
                            <div className="mt-4">
                                <SelectParentProductList
                                    podDetail={selectedPod}
                                    selectedParentProductList={selectedParentProductList}
                                    setSelectedParentProductList={setSelectedParentProductList}
                                    tableClassName={'select-products-table-container'}
                                    filterCriteria={parentProductFilterCriteria}
                                    setFilterCriteria={setParentProductFilterCriteria}/>
                            </div>
                        </div>
                    }

                    {selectedTab?.key === 'images' &&
                        <div className="mt-4">
                            <SelectImageList
                                selectedImageList={selectedImageList}
                                setSelectedImageList={setSelectedImageList}
                                prepareSelectedImageList={() => {
                                }}
                                filterCriteria={imageFilterCriteria}
                                setFilterCriteria={setImageFilterCriteria}
                                allThemes={themeList}
                                allTags={tagList}/>
                        </div>
                    }

                    {selectedTab?.key === 'products-designer' && selectedParentProduct && designsMap &&
                        <div className="mt-4">
                            <ProductsDesigner
                                showGrid={showGrid}
                                designsMap={designsMap}
                                setDesignsMap={setDesignsMap}
                                processedImageList={processedImageList}
                                parentProduct={selectedParentProduct}
                                setSelectedParentProduct={setSelectedParentProduct}
                                selectedParentProductList={selectedParentProductList}
                                downloadAllImages={downloadAllImages}
                                setDownloadAllImages={setDownloadAllImages}/>
                        </div>
                    }


                </div>

            </div>

        </>
    )
}

export default MultiProductsDesignerDashboard
